<template>
  <nav class="flex items-center gap-9">
    <router-link
      v-for="menu in DESKTOP_NAV_MENUS"
      :key="menu.id"
      :to="{ name: menu.to, params: menu.params }"
      class="decoration-none whitespace-nowrap text-lg font-semibold text-white"
      :class="{ '!text-primary': $route.name === menu.to }"
    >
      {{ menu.text }}
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { DESKTOP_NAV_MENUS } from '@/constants/desktopNavMenus';
</script>
